import { Button, Container, FormControl, InputLabel, MenuItem, Pagination, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Backend } from "../../services/Backend";
import Loader from "../../components/Loader";
import NewsItem from "../../components/NewsItem";
import { useSearchParams } from "react-router-dom";

export default function SearchNewsPage() {
    const [searchParams, setSearchParams] = useSearchParams();

    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [foundNews, setFoundNews] = useState(0);
    const [searchQuery, setSearchQuery] = useState(searchParams.get('search') ? searchParams.get('search') : "");
    const [data, setData] = useState([]);


    const fetchDocuments = () => {
        Backend.get(`news?page=${page - 1}&search=${searchQuery}`)
            .then(res => {
                setData(res.data)
                setFoundNews(res.totalCount);
                setIsLoading(false);
                if (res.data.length > 0)
                    setTotalPages(Math.ceil(res.totalCount / res.data.length))
            });
    }

    useEffect(() => {
        fetchDocuments();
    }, []);

    const handlePageChange = (e, newPage) => {
        setPage(newPage);

        Backend.get(`news?page=${newPage - 1}&search=${searchQuery}`)
        .then(res => {
            setData(res.data)
            setFoundNews(res.totalCount);
            setIsLoading(false);
            if (res.data.length > 0)
                setTotalPages(Math.ceil(res.totalCount / res.data.length))
        });
    }

    const handleSearch = () => {
        fetchDocuments();
    }
    
    return <Container maxWidth="lg" className="my-5">
         <div className="flex gap-3">
            <TextField margin="normal" size="small" required fullWidth label="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}  />
            <Button  variant="contained" sx={{ mt: 2, mb: 1 }} onClick={handleSearch}>Search</Button>
        </div>
        
        <p className="my-2">Found <b>{foundNews}</b> news</p>
        <hr />

        {isLoading ? <div className="mx-auto w-fit mt-4">
            <Loader />
            </div> : <>
                <div className="mt-2">
                    {data.map(item => <NewsItem data={item} linkTo={`/news/${item.id}`} />)}
                </div> 
                <Pagination count={totalPages} color="primary"  page={page} onChange={handlePageChange} />
            </>
        }
    </Container>
}